import { render, staticRenderFns } from "./ProgramUnionHistoryItem.vue?vue&type=template&id=21994fa0&scoped=true&"
import script from "./ProgramUnionHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ProgramUnionHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./ProgramUnionHistoryItem.vue?vue&type=style&index=0&id=21994fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21994fa0",
  null
  
)

export default component.exports